module.exports = __webpack_public_path__ + "img/icon_nodata.6303f38c.svg";